import SectionSeven from "../Componets/SectionSeven"
import Footer from "../Componets/Footer";

import '../styles/style.css'

export default function Contact() {
    return (
        <>
            <div className="space-in-page" ></div>
            <SectionSeven />
            <Footer />
            
        </>
    );
}
